module.exports = __webpack_public_path__ + "static/hero-sala-tecnica-1200-1a3303c88b3ac08b6be0c42f117c95ff.jpg";